export const NAVIGATION = {
  logo: 'nav-logo',
  bookBtn: 'nav-book-btn',
  loginBtn: 'nav-login-btn',
  accountBtn: 'nav-account-btn',
  adminBtn: 'nav-admin-btn',
  logoutBtn: 'nav-logout-btn',
  mobileMenuToggle: 'mobile-menu-toggle',
};

export const HOME = {
  hero: 'home-hero',
  bookNowBtn: 'home-book-now-btn',
  featuredServices: 'home-featured-services',
};

export const AUTH = {
  loginForm: 'login-form',
  registerForm: 'register-form',
  emailInput: 'auth-email-input',
  passwordInput: 'auth-password-input',
  submitBtn: 'auth-submit-btn',
};

export const BOOKING = {
  serviceSelect: 'booking-service-select',
  staffSelect: 'booking-staff-select',
  dateInput: 'booking-date-input',
  timeSelect: 'booking-time-select',
  submitBtn: 'booking-submit-btn',
};

export const ADMIN = {
  dashboard: 'admin-dashboard',
  servicesTab: 'admin-services-tab',
  staffTab: 'admin-staff-tab',
  calendarTab: 'admin-calendar-tab',
  createServiceBtn: 'admin-create-service-btn',
  generateImageBtn: 'admin-generate-image-btn',
};
